"use strict";
/*
 * Created on 2. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../utils");

var Pagination_1 = require("../Pagination");

var PaginationConverter_1 = require("./PaginationConverter");
/**
 * Default implementation of {@link PaginationConverter}.
 *
 * @author Radek Beran
 */


var PaginationConverterImpl =
/*#__PURE__*/
function (_PaginationConverter_) {
  _inherits(PaginationConverterImpl, _PaginationConverter_);

  function PaginationConverterImpl() {
    _classCallCheck(this, PaginationConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PaginationConverterImpl).apply(this, arguments));
  }

  _createClass(PaginationConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new Pagination_1.Pagination(source.limit, source.offset, utils_1.Utils.isValueMissing(source.totalCount) ? null : source.totalCount);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      document = Object.assign(document, {
        limit: source.limit,
        offset: source.offset,
        totalCount: source.totalCount
      });
      return document;
    }
  }]);

  return PaginationConverterImpl;
}(PaginationConverter_1.PaginationConverter);

exports.PaginationConverterImpl = PaginationConverterImpl;